module.exports = __webpack_public_path__ + "d770526cf39763115f3cb3a66eeb42d7.mp3";